import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MutasiAntarCounterPageRoutingModule } from './mutasi-antar-counter-routing.module';

import { MutasiAntarCounterPage } from './mutasi-antar-counter.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MutasiAntarCounterPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [MutasiAntarCounterPage]
})
export class MutasiAntarCounterPageModule {}
